import { LISCaseList, LISSlide } from "pwapi";

import { StainList } from "custom-models/frontLoader";

import { labelForBlock } from "./blockUtils";

// TODO: Delete this file and use shared/utils/slideUtils instead once those functions are using frontloaded Stains instead of nested Slide.stains

export const stainTemplate = (slide: LISSlide, stain: StainList) => {
  return `${slide.is_control ? "CL-" : ""}${slide.is_rescan ? "RS-" : ""}${
    stain?.abbreviation
  }`;
};

export const labelForSlide = (
  slide: LISSlide,
  slideCase?: LISCaseList,
  stain?: StainList
) => {
  const block = slideCase?.blocks.find((b) => b.id === slide.block_obj_id);

  return `${labelForBlock(block, slideCase)} ${
    stain ? stainTemplate(slide, stain) : ""
  } S${slide.slide_number || ""}`;
};
